// Types/constants

export default {
  // sentinel for uninitialized user (null user represents being logged out)
  loadingUser: 'loadingUser'
}



// WEBPACK FOOTER //
// ./src/types.js